import { Divider } from "@mui/material";
import { navbarHeight } from "./navbar";

export const editHeight = 20;

export default function TopEditMenu({ children }) {
    return <>
        <div style={{
            position: 'fixed',
            top: navbarHeight,
            height: editHeight,
            width: 'calc(100% - 20px)',
            zIndex: 10000,
            backgroundColor: '#FFF',
            display: 'flex',
            alignItems: 'center',
            flexDirection: 'row',
            padding: '0 10px',
            boxShadow: '0 -1px 5px black'
        }}>
            {children}
        </div>
        <div style={{height: editHeight}}/>
    </>
}

export function EditMenuSeparator() {
    return <div style={{margin: '0 10px', height: '100%'}}>
        <Divider orientation="vertical"/>
    </div>;
}